<template>
  <div class="tab__content brackets">
    <div class="title">Сетка турнира</div>

    <div v-if="!hasBracketData && loading" class="brackets-loading">
      Загружаем сетку турнира...
    </div>
    <div v-else-if="!hasBracketData" class="brackets-empty">
      Сетка турнира не найдена или еще не составлена
    </div>
    <div key="brackets" v-else>
      <TournamentBracket
        :bracket="bracketData"
        :grandFinal="null"
        type="single"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import mapValues from "lodash/mapValues";
import tournamentsService from "@/services/tournaments";
import TournamentBracket from "@/components/tournament/TournamentBracket";

export default {
  components: {
    TournamentBracket
  },
  data: () => ({
    bracketData: null,

    loading: false,
    query: null,
    matches: [],
    pagination: {}
  }),

  computed: {
    hasBracketData() {
      return !!this.bracketData && Object.keys(this.bracketData).length > 0;
    },

    ...mapGetters(["routeParams"])
  },

  watch: {
    routeParams: "fetchPageData"
  },

  sockets: {
    notification(message) {
      const isAllowed = ["matches_performed", "tournament_changed"].includes(
        message.type
      );
      const onCurTournament =
        this.routeParams.tournament_id === message.tournament_id;

      if (isAllowed && onCurTournament) {
        this.fetchPageData();
      }
    }
  },

  methods: {
    formatMatchesForBracket(data) {
      let matches = [...data];

      matches = matches.map(o => {
        const {
          winner,
          player1_nickname,
          player2_nickname,
          player1_score: team1_score,
          player2_score: team2_score,
          ...match
        } = o;

        const isEmptyMatch = !player1_nickname && !player2_nickname;

        return {
          ...match,
          team1: { title: isEmptyMatch ? "Пустой слот" : player1_nickname },
          team2: { title: isEmptyMatch ? "Пустой слот" : player2_nickname },
          match: isEmptyMatch
            ? null
            : {
                ...match,
                team1_score,
                team2_score,
                winner: winner ? `team${winner}` : null
              }
        };
      });

      matches.sort((a, b) => a.order - b.order);

      return matches;
    },

    async fetchPageData() {
      if (this.loading) return;
      this.loading = true;

      const data = await tournamentsService.getBracket(
        this.routeParams.tournament_id
      );

      this.bracketData = mapValues(data, this.formatMatchesForBracket);

      this.loading = false;
      this.$store.dispatch("tournaments/updateTournament");
    }
  },

  created() {
    this.fetchPageData();
  }
};
</script>

<style lang="scss">
.brackets {
  &-loading,
  &-empty {
    background: rgba(0, 10, 37, 0.6);
    border-radius: 6px;
    text-align: center;
    padding: 30px;
  }

  .title {
    font-size: 24px;
    line-height: 33px;
    text-transform: uppercase;
    margin-bottom: 20px;
  }

  &__info {
    margin-bottom: 30px;
  }

  &__message {
    text-align: center;
    font-size: 21px;
  }
}
</style>
